import React from "react";

import Dialog from "../dialog/Dialog";
import DialogClose from "../dialog/DialogClose";
import DialogContent from "../dialog/DialogContent";
import DialogFooter from "../dialog/DialogFooter";

import "./PreviewDialog.scss";

interface PreviewDialogProps {
    open: boolean;
    previewData: string;
    previewClosed: Function;
}

interface PreviewDialogState {}

class PreviewDialog extends React.Component<
    PreviewDialogProps,
    PreviewDialogState
> {
    state = {};

    render(): React.ReactNode {
        return (
            <Dialog
                dialogTitle="Print Preview"
                dialogIcon="find_in_page"
                showDialog={this.props.open}
                width={900}
                zIndex={1000}>
                <DialogContent className="print-preview-dialog">
                    <iframe
                        title="Print Preview"
                        src={this.props.previewData}>
                    </iframe>
                </DialogContent>
                <DialogFooter>
                    <DialogClose onClick={this.props.previewClosed}></DialogClose>
                </DialogFooter>
            </Dialog>
        );
    }
}

export default PreviewDialog;
